import Helper from './Helper';

class SymbolCircle {
  constructor(config = {}) {
    const {
      cellSelector = '.ns-table-wrap table td, .ns-table-wrap table th',
      matchValue = 'sym-p',
      circleClass = 'ns-table-symbol-circle',
      circleSizeFactor = 0.9
    } = config;

    this.cellSelector = cellSelector;
    this.matchValue = matchValue.toLowerCase();
    this.circleClass = circleClass;
    this.circleSizeFactor = circleSizeFactor;

    this.cells = Array.prototype.slice.call(document.querySelectorAll(this.cellSelector));

		// console.log("cells", this.cells);

    if (this.cells.length > 0) {
      this.replaceContent();
    }
  }

  replaceContent() {
    this.cells.forEach(cell => {
      if (!cell || cell.dataset.symbolCircleProcessed === 'true') {
        return;
      }

      const text = (cell.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

      if (text === this.matchValue) {
        this.createCircle(cell);
      }
    });
  }

  createCircle(cell) {
    cell.dataset.symbolCircleProcessed = 'true';
    cell.textContent = '';
    cell.style.textAlign = 'center';
    cell.style.verticalAlign = 'middle';

    const circle = document.createElement('span');
    circle.setAttribute('aria-hidden', 'true');
    circle.style.display = 'inline-block';
    circle.style.borderRadius = '50%';
    circle.style.backgroundColor = 'currentColor';
    circle.style.verticalAlign = 'middle';
    circle.style.flexShrink = '0';

    const computed = window.getComputedStyle(cell);
    const fontSize = parseFloat(computed.fontSize || '0');
    const circleSize = fontSize > 0 ? Math.max(fontSize * this.circleSizeFactor, 6) : 10;

    circle.style.width = `${circleSize}px`;
    circle.style.height = `${circleSize}px`;

    Helper.addClass(circle, this.circleClass);

    const wrapper = document.createElement('span');
    wrapper.style.display = 'flex';
    wrapper.style.alignItems = 'center';
    wrapper.style.justifyContent = 'flex-start';
    wrapper.style.width = '100%';
    wrapper.style.height = '100%';
    wrapper.style.minHeight = `${circleSize}px`;

    wrapper.appendChild(circle);
    cell.appendChild(wrapper);
  }
}

export default SymbolCircle;
